"use client";

import React from "react";
import type { ActionPayload } from "./types";
import { inputCls, labelCls, ACTION_SUBTYPES } from "./constants";

export function ActionForm({
  p,
  onChange,
}: {
  p: ActionPayload;
  onChange: (p: ActionPayload) => void;
}) {
  return (
    <>
      <div>
        <label className={labelCls}>Aktionstyp</label>
        <div className="flex gap-1.5">
          {ACTION_SUBTYPES.map((s) => (
            <button
              key={s.value}
              onClick={() => onChange({ ...p, subtype: s.value })}
              className={`flex flex-1 items-center justify-center rounded-xl border py-2 text-xs font-medium transition ${
                p.subtype === s.value
                  ? "border-amber-500/40 bg-amber-500/10 text-amber-400"
                  : "border-gray-200 text-gray-500 dark:border-white/10"
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>
      {p.subtype === "local_function" && (
        <div>
          <label className={labelCls}>Signatur</label>
          <textarea
            className={`${inputCls} resize-none font-mono text-xs`}
            rows={3}
            placeholder="async function process(id: string): Promise<Result>"
            value={p.functionSignature ?? ""}
            onChange={(e) =>
              onChange({ ...p, functionSignature: e.target.value })
            }
          />
        </div>
      )}
      {p.subtype === "external_api" && (
        <div className="flex gap-2">
          <div className="w-24">
            <label className={labelCls}>Methode</label>
            <select
              className={inputCls}
              value={p.httpMethod ?? "GET"}
              onChange={(e) =>
                onChange({
                  ...p,
                  httpMethod: e.target.value as ActionPayload["httpMethod"],
                })
              }
            >
              {["GET", "POST", "PUT", "PATCH", "DELETE"].map((m) => (
                <option key={m}>{m}</option>
              ))}
            </select>
          </div>
          <div className="flex-1">
            <label className={labelCls}>Endpoint</label>
            <input
              className={inputCls}
              placeholder="https://api.example.com/v1/…"
              value={p.endpoint ?? ""}
              onChange={(e) => onChange({ ...p, endpoint: e.target.value })}
            />
          </div>
        </div>
      )}
      {p.subtype === "llm_prompt" && (
        <>
          <div>
            <label className={labelCls}>System Prompt</label>
            <textarea
              className={`${inputCls} resize-none font-mono text-xs`}
              rows={3}
              placeholder="Du bist ein Assistent der…"
              value={p.systemPrompt ?? ""}
              onChange={(e) => onChange({ ...p, systemPrompt: e.target.value })}
            />
          </div>
          <div>
            <label className={labelCls}>User Template</label>
            <textarea
              className={`${inputCls} resize-none font-mono text-xs`}
              rows={2}
              placeholder="Analysiere: {{input}}"
              value={p.userTemplate ?? ""}
              onChange={(e) => onChange({ ...p, userTemplate: e.target.value })}
            />
          </div>
        </>
      )}
    </>
  );
}
